/**
 * VIP 礼包推荐相关接口
 */
import request from '@/utils/request';
import CryptoJS from 'crypto-js';

// ========== Mock 数据开关 ==========
// 开发测试时设置为 true，接口上线后设置为 false
const USE_MOCK = false;

// ========== Mock 场景切换 ==========
// 切换不同的测试场景来验证红点显示逻辑
// 场景1: 所有tab都有礼包 - 所有tab都应该有红点
// 场景2: 部分tab有礼包 - 只有有礼包的tab显示红点
// 场景3: 部分tab礼包列表为空 - 空列表的tab不显示红点
const MOCK_SCENE = 2;  // 当前使用场景2

// ========== Mock 数据定义 ==========
const MOCK_DATA = {
  // 用户信息（游戏已绑定）
  userInfo: {
    content: {
      user_data_list: [
        {
          major_id: 'game001',
          major_name: '仙侠传奇',
          role_id: '10001',
          role_name: '剑圣无敌',
          role_create_time: '2024-12-20 10:30:00'
        },
        {
          major_id: 'game001',
          major_name: '仙侠传奇',
          role_id: '10002',
          role_name: '法师之光',
          role_create_time: '2024-12-15 15:20:00'
        },
        {
          major_id: 'game002',
          major_name: '三国争霸',
          role_id: '20001',
          role_name: '关羽',
          role_create_time: '2024-12-18 09:00:00'
        }
      ],
      yuewan_user_data_list: [
        {
          major_id: 'game003',
          major_name: '魔幻世界',
          role_id: '30001',
          role_name: '暗夜精灵',
          role_create_time: '2024-12-22 14:00:00'
        }
      ]
    }
  },
  
  // 用户信息（游戏未绑定）
  userInfoUnbound: {
    content: {
      user_data_list: [],
      yuewan_user_data_list: []
    }
  },
  
  // VIP信息（已接入状态）
  vipInfo: {
    content: {
      vip_status: 1, // 0未分配 1已接入 2未接入 3已出库
      assign_time: '2024-12-20 10:00:00',
      join_time: '2024-12-21 14:30:00',
      charge_person: '张三',
      role_list: [
        {
          major_id: 'game001',
          major_name: '仙侠传奇',
          role_id: '10001',
          role_name: '剑圣无敌',
          role_create_time: '2024-12-20 10:30:00',
          role_level: 88
        },
        {
          major_id: 'game001',
          major_name: '仙侠传奇',
          role_id: '10002',
          role_name: '法师之光',
          role_create_time: '2024-12-15 15:20:00',
          role_level: 75
        },
        {
          major_id: 'game002',
          major_name: '三国争霸',
          role_id: '20001',
          role_name: '关羽',
          role_create_time: '2024-12-18 09:00:00',
          role_level: 92
        }
      ]
    }
  },
  
  // VIP礼包列表 - 场景1：所有tab都有礼包（5个红点）
  // type: 1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包
  giftListScene1: {
    content: {
      today_gift_list: [
        {
          type: 1,
          money: '1288.00',
          gift_list: [
            {
              gift_id: 'daily_001',
              name: '每日豪华礼包',
              type: 1,
              money: '98',
              is_admin_fetch: 1,
              receive_status: 0
            },
            {
              gift_id: 'daily_002',
              name: '每日至尊礼包',
              type: 1,
              money: '198',
              is_admin_fetch: 0,
              receive_status: 0
            }
          ]
        },
        {
          type: 2,
          money: '3500.00',
          gift_list: [
            {
              gift_id: 'weekly_001',
              name: '周卡特惠礼包',
              type: 2,
              money: '328',
              is_admin_fetch: 1,
              receive_status: 0
            }
          ]
        },
        {
          type: 3,
          money: '8888.00',
          gift_list: [
            {
              gift_id: 'monthly_001',
              name: '月度尊享礼包',
              type: 3,
              money: '998',
              is_admin_fetch: 1,
              receive_status: 0
            }
          ]
        },
        {
          type: 4,
          money: '25680.00',
          gift_list: [
            {
              gift_id: 'total_001',
              name: '总充值大礼包',
              type: 4,
              money: '5000',
              is_admin_fetch: 1,
              receive_status: 0
            },
            {
              gift_id: 'total_002',
              name: '总充值超级礼包',
              type: 4,
              money: '10000',
              is_admin_fetch: 0,
              receive_status: 0
            }
          ]
        },
        {
          type: 5,
          money: '18888.00',
          gift_list: [
            {
              gift_id: 'total_monthly_001',
              name: '总充值月度礼包',
              type: 5,
              money: '3000',
              is_admin_fetch: 1,
              receive_status: 0
            }
          ]
        }
      ],
      history_money: '688.00',
      history_gift_list: [
        {
          gift_id: 'history_001',
          name: '历史单日礼包A',
          type: 1,
          money: '98',
          is_admin_fetch: 1,
          receive_status: 0
        }
      ]
    }
  },
  
  // VIP礼包列表 - 场景2：部分tab有礼包（日礼包和周礼包有红点，其他没有）
  giftListScene2: {
    content: {
      today_gift_list: [
        {
          type: 1,
          money: '1288.00',
          gift_list: [
            {
              gift_id: 'daily_001',
              name: '每日豪华礼包',
              type: 1,
              money: '98',
              is_admin_fetch: 1,
              receive_status: 0
            }
          ]
        },
        {
          type: 2,
          money: '3500.00',
          gift_list: [
            {
              gift_id: 'weekly_001',
              name: '周卡特惠礼包',
              type: 2,
              money: '328',
              is_admin_fetch: 1,
              receive_status: 0
            }
          ]
        },
        {
          type: 3,
          money: '8888.00',
          gift_list: []
        },
        {
          type: 4,
          money: '25680.00',
          gift_list: []
        },
        {
          type: 5,
          money: '18888.00',
          gift_list: []
        }
      ],
      history_money: '0',
      history_gift_list: []
    }
  },
  
  // VIP礼包列表 - 场景3：只有1个tab有礼包（只有总充值礼包有红点）
  giftListScene3: {
    content: {
      today_gift_list: [
        {
          type: 1,
          money: '0',
          gift_list: []
        },
        {
          type: 2,
          money: '0',
          gift_list: []
        },
        {
          type: 3,
          money: '0',
          gift_list: []
        },
        {
          type: 4,
          money: '25680.00',
          gift_list: [
            {
              gift_id: 'total_001',
              name: '总充值大礼包',
              type: 4,
              money: '5000',
              is_admin_fetch: 1,
              receive_status: 0
            },
            {
              gift_id: 'total_002',
              name: '总充值超级礼包',
              type: 4,
              money: '10000',
              is_admin_fetch: 0,
              receive_status: 0
            },
            {
              gift_id: 'total_003',
              name: '总充值至尊礼包',
              type: 4,
              money: '20000',
              is_admin_fetch: 1,
              receive_status: 0
            }
          ]
        },
        {
          type: 5,
          money: '0',
          gift_list: []
        }
      ],
      history_money: '0',
      history_gift_list: []
    }
  },
  
  // 领取上报成功（只返回礼包码）
  receiveGift: {
    ret: 1,
    gift_code: 'GIFT' + Math.random().toString(36).substring(2, 10).toUpperCase()
  },
  
  // 领取礼包失败
  receiveGiftFailed: {
    ret: -1,
    message: '礼包码已发放完'
  }
};

// 获取企微小程序接口域名
const getQwEnv = function () {
  if (process.env.NODE_ENV === 'development') {
    return '//h5test.hzwxbz999.cn';
  } else {
    switch (window.location.hostname) { 
      case 'worksntest.hzwxbz999.cn':
      case 'worksn-manage-test.1uoang.cn':
        return '//h5test.hzwxbz999.cn';
      case 'worksnpre.hzwxbz999.cn':
      case 'worksn-manage-pre.1uoang.cn':
      case 'worksn-manage-pre.hzlz123.cn':
        return '//h5.hzwxbz999.cn';
      case 'worksn-manage.lingchan521.cn':
        return '//h5.lingchan521.cn';
      case 'worksn-manage.hzkl521.cn':
        return '//h5.hzkl521.cn';
      case 'worksn-manage.qyou22.cn':
        return '//h5.qyou22.cn';
      case 'worksn-manage.1uoang.cn':
        return '//h5.1uoang.cn';
      default:
        return '//h5.hzlz123.cn';
    }
  }
};

/** 企微场景下 IM/SSE（/sse/stream）。线上与预发及原各管理端域名均只连 //h5ntty.hzwxbz2.cn；仅测试环境连 h5ntty-test。 */
const getQwSseEnv = function () {
  if (process.env.NODE_ENV === 'development') {
    return '//h5ntty-test.hzwxbz999.cn';
  }
  switch (window.location.hostname) {
    case 'worksntest.hzwxbz999.cn':
    case 'worksn-manage-test.1uoang.cn':
      return '//h5ntty-test.hzwxbz999.cn';
    default:
      return '//h5ntty.hzwxbz2.cn';
  }
};

// 生成参数签名
const sortASCII = function (obj) {
  let arr = [];
  let num = 0;
  const secret = 'TKGKItgT';
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
  sortArr = sortArr.map((item) => {
    return item + '=' + obj[item];
  });
  let sortString = sortArr.join('&') + secret;
  return {
    ...obj,
    sign: CryptoJS.MD5(sortString).toString().toLowerCase(),
  };
};

/**
 * 企微授权登录 - 通过 code 获取客服 userId
 * @param {Object} params - { code, corpid, agentid }
 * @returns {Promise<{ ret: number, content: { contact_userid: string } }>}
 */
export async function oauthLoginApi(params) {
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/oauth-login',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 获取用户信息（判断游戏是否已绑定）
 * @param {Object} params - { corpid, external_userid, pay_begin_time?, pay_end_time?, ... }
 */
export async function getUserInfoApi(params) {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(MOCK_DATA.userInfo);
      }, 300);
    });
  }
  
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/external-user-info',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 获取企微签名
 * @param {Object} params - { url, corpid, agentid? }
 */
export async function getQwSignatureApi(params) {
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/signature',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 获取VIP信息
 * @param {Object} params - { corpid, external_userid, type }
 * - type: 'wanxin' 玩心 | 'yuewan' 悦玩
 * @returns {Promise<{ content: { vip_status, assign_time, join_time, charge_person, role_list: [{ major_id, major_name, role_id, role_name, ... }] } }>}
 */
export async function getVipInfoApi(params) {
  // if (USE_MOCK) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(MOCK_DATA.vipInfo);
  //     }, 300);
  //   });
  // }
  
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/external-vip-info',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 获取VIP礼包信息
 * @param {Object} params - { corpid, external_userid, role_id, major_id, type, check_date? }
 * - type: 'wanxin' 玩心 | 'yuewan' 悦玩
 * - major_id: 游戏标识（原 appkey）
 * @returns {Promise<{ content: { today_gift_list: [{ type: number, money: string, gift_list: [...] }], history_money?, history_gift_list? } }>}
 * - type 字段: 1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包
 * - gift_list 中的礼包对象包含字段：
 *   - gift_id: 礼包ID
 *   - name: 礼包名称
 *   - type: 礼包类型
 *   - money: 金额档位
 *   - receive_status: 领取状态（0=可领取 1=已领取 2=不可领取）
 *   - is_admin_fetch: 主管领取状态（0=未领取 1=已领取）
 */
export async function getVipGiftListApi(params) {
  // if (USE_MOCK) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       let mockData;
  //       switch (MOCK_SCENE) {
  //         case 1:
  //           mockData = MOCK_DATA.giftListScene1;
  //           break;
  //         case 2:
  //           mockData = MOCK_DATA.giftListScene2;
  //           break;
  //         case 3:
  //           mockData = MOCK_DATA.giftListScene3;
  //           break;
  //         default:
  //           mockData = MOCK_DATA.giftListScene2;
  //       }
  //       resolve(mockData);
  //     }, 500);
  //   });
  // }
  
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/external-vip-gift',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 领取VIP礼包
 * @param {Object} params - { corpid, external_userid, role_id, major_id, gift_id, type, contact_userid, user_id, vip_id, gift_type, receive_status }
 * - type: 'wanxin' 玩心 | 'yuewan' 悦玩
 * - major_id: 游戏标识（原 appkey）
 * - contact_userid: 客服员工 userId
 * - user_id: 用户ID（从 external-vip-info 接口获取）
 * - vip_id: VIP ID（从 external-vip-info 接口获取）
 * - gift_type: 礼包类型 int（1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包）
 * - receive_status: 领取状态 int（0=可领取 1=已领取）
 * @returns {Promise<{ ret: number, gift_code: string, content: string }>}
 * - gift_code: 礼包码
 * - content: 礼包内容
 */
export async function receiveVipGiftApi(params) {
  // if (USE_MOCK) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const success = Math.random() > 0.1;
  //       if (success) {
  //         const mockData = {
  //           ret: 0,
  //           content: {
  //             gift_code: 'GIFT' + Math.random().toString(36).substring(2, 10).toUpperCase(),
  //             gift_content: '钻石*2000、金币*100000、高级装备箱*5、经验药水*20'
  //           }
  //         };
  //         resolve(mockData);
  //       } else {
  //         resolve(MOCK_DATA.receiveGiftFailed);
  //       }
  //     }, 400);
  //   });
  // }
  
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/external-vip-gift-receive',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

// 导出工具方法供组件使用
export { getQwEnv, getQwSseEnv, sortASCII };
